import { useRouter } from 'next/router'
import { useEffect } from 'react'

import { MAPS_LIMIT } from '~workspace/constants/maps'
import useSearchMapsByWorkspaceIdQuery from '~workspace/hooks/useSearchMapsByWorkspaceIdQuery'
import MapList from './MapList'
import MapsTabTools from './MapsTabTools'
import { View } from './view'

const Maps = () => {
  const router = useRouter()
  const { workspaceId, page, query, tags } = router.query
  const offset =
    page && !isNaN(Number(page)) ? (parseInt(page) - 1) * MAPS_LIMIT : 0

  const { refetch } = useSearchMapsByWorkspaceIdQuery()

  useEffect(() => {
    if (workspaceId) {
      refetch({
        workspaceId: workspaceId,
        limit: MAPS_LIMIT,
        offset: offset,
        query,
        tagIds: (tags && tags.split(',')) || []
      })
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [workspaceId, offset, query, tags])

  return (
    <View
      slots={{
        MapsTabTools,
        MapList
      }}
    />
  )
}

export { Maps }
export default Maps
